/* global chrome */
'use strict';

import { setInSessionStorage, getFromSessionStorage, removeFromSessionStorage } from '../util/session-storage-wrapper';
import ErrorType from '../constants/error-type';

import * as domUtils from '../util/dom';
var statsUtil = require('../util/stats');
var VideoConfig = require('../config');
var Sizzle = require('sizzle');
var Debug = require('../util/debug')('chromecast');
import AudioTrack from '../constants/audio-track';

const EVENT_NAMESPACE = 'chromecast';
const CAPTIONS_STORAGE_KEY = "captionsOn";
const AUDIO_STORAGE_KEY = 'audioTrack';

module.exports = {
	create: function (api) {

		if (!window.chrome) {
			return;
		}

		var APPLICATION_ID = VideoConfig.chromecastReceiverId,
			START_BITRATE = 3000,
			MAX_BITRATE = 9000,
			SESSION_KEY = "chromecastEnabled";

		var NAMESPACE = {
			ERROR: 'urn:x-cast:svt.chromecast.error',
			SEND_COMMAND: 'urn:x-cast:svt.chromecast.command'
		};

		var COMMANDS = {
			SUBS_ON : "SUBS_ON",
			SUBS_OFF : "SUBS_OFF",
			SUBS_STATUS : "SUBS_STATUS",
			NO_SUBS : "NO_SUBS",
			WAN_CONNECTION_LOST: "WAN_CONNECTION_LOST",
			WAN_CONNECTION_RESTORED: "WAN_CONNECTION_RESTORED",
            AUDIO_DEFAULT: "AUDIO_DEFAULT",
            AUDIO_SPOKEN: "AUDIO_SPOKEN"
		};

		var STATUS = {
			INACTIVE: 0,
			ACTIVE: 1,
			LOADING: 2,
			PLAYING: 3,
			PAUSED: 4,
			SEEKING: 5,
			BUFFERING: 6,
			IDLE: 7,
			OTHER_VIDEO_PLAYING: 8,
			ERROR: 9,
			CONNECTING: 10
		};

		var ICON = {
			CC_OFF: 'svp_chromecast__button-not-connected',
			CC_ON: 'svp_chromecast__button-connected',
			CC_CONNECTING_0: 'svp_chromecast__button-connecting-1',
			CC_CONNECTING_1: 'svp_chromecast__button-connecting-2',
			CC_CONNECTING_2: 'svp_chromecast__button-connecting-3',
			CC_CONNECTING_3: 'svp_chromecast__button-connecting-2',
			PAUSE: 'svt_icon--pause',
			STOP: 'svt_icon--stop'
		};

		function _sendEvent(eventType, data) {
			if (api.fire) {
				api.fire(eventType, data);
			}
		}

		this.chromecastController = {
			_startPosition: null,
			_autostart: false,
			_sessionStorageTimeout: null,
			_videoData: null,
			_buttonIconLoadingTimer: null,
			_subAvailableSent: false,
			error: false,
			disallowed: false,
			session: null,

			setMetadata: function (metadata) {
				this._videoData = metadata.detail;
			},

			loadChromeCast: function () {
				var _this = this;

				this._sessionStorageTimeout = setTimeout(function () {
					if (window.sessionStorage) {
						sessionStorage.removeItem(SESSION_KEY);
					}
					// TODO: this should be some sort of reset
				}, 5000);

				if (this.hasLocalSession()) {
					api.data().allowNoUi = false;
					api.data().isRemote = true;
				}

				this._loadChromeCastSDK(function () {
					if (!chrome.cast || !chrome.cast.isAvailable) {
						var _intervalTimer = setInterval(function () {
							if (chrome.cast && chrome.cast.isAvailable) {
								clearInterval(_intervalTimer);
								_this._initChromeCast();
							}
						}, 1000);
					} else {
						_this._initChromeCast();
					}
				});

				api.on(EVENT_NAMESPACE + '.error', function () {
					_this.error = true;
				});
			},

			_initChromeCast: function () {
				if (!chrome.cast.SessionRequest) {
					return;
				}

				var sessionRequest = new chrome.cast.SessionRequest(APPLICATION_ID);
				var apiConfig = new chrome.cast.ApiConfig(sessionRequest,
					this._sessionFoundListener.bind(this),
					this._receiverListener.bind(this),
					chrome.cast.AutoJoinPolicy.TAB_AND_ORIGIN_SCOPED
				);

				chrome.cast.initialize(apiConfig, this._onInitSuccess.bind(this), this._onInitError.bind(this));
			},

			_loadChromeCastSDK: function (callback) {
				if (!chrome.cast) {
					domUtils.getScript('https://www.gstatic.com/cv/js/sender/v1/cast_sender.js').then(() => {
					    callback();
                    });
				} else {
					callback();
				}
			},

			_sessionFoundListener: function (session) {
				// Exit early if we've already been destroyed
				if (!api.state()) {
					return;
				}
				this.session = session;
				api.data().allowNoUi = false;
				api.data().isRemote = true;

				this.session.addMessageListener(NAMESPACE.SEND_COMMAND, this._sessionCommandListener.bind(this));
				this._setChromecastButtonState(STATUS.ACTIVE);
				clearTimeout(this._sessionStorageTimeout);

                setInSessionStorage(SESSION_KEY, true);

				var media = this.getMedia(session);
				if (media) {
					var currVideoId = media.media.customData.videoId,
						state = media.playerState;

					if (api.data().videoId === currVideoId) {
						this._isCurrentCastVideo = true;
						this._initMediaListeners();
						this._sendCommand(COMMANDS.SUBS_STATUS);

						_sendEvent('play');
						if (state === chrome.cast.media.PlayerState.PLAYING || state === chrome.cast.media.PlayerState.BUFFERING) {
							_sendEvent('playing');
							this.startProgressTimer();
						} else {
							_sendEvent('pause');
							this.stopProgressTimer();
						}

						this.duration = media.media.duration;

						this.currentTime = media.currentTime;
						this.updateProgress();
						_sendEvent('volumechange');
					} /*else {
					 //MessageChannel.publish('/player/chromecast/othervideo/' + this.video.playerID);
					 }*/

				} else if (this._autostart) {
					this._loadMediaOnChromecast();
					this._autostart = false;
				} /*else {
				 //MessageChannel.publish('/player/chromecast/idle/' + this.video.playerID, this.session.receiver.friendlyName);
				 }*/

				this.session.addUpdateListener(this._sessionUpdateListener.bind(this));
			},

			_getChromecastButton: function () {
				var button = Sizzle('.svp_chromecast-button', api.element());

				if (!button.length && !this.buttonInserted) {
					button = domUtils.fromString('<div class="svp_chromecast-button"></div>');
					var _this = this;
					domUtils.addEvents(button, 'click, touchend', function (e) {
						Debug('CC clicked');
						e.stopPropagation();
						_this._requestSession();
					});

					api.insertButton(button);
					this.buttonInserted = true;
				}

				return button;
			},

			_receiverListener: function (receiverState) {

				if (api.state() && !this.disallowed) {
					if (receiverState === chrome.cast.ReceiverAvailability.AVAILABLE) {
						domUtils.show(this._getChromecastButton());
						this._setChromecastButtonState(STATUS.INACTIVE);
					} else if (this._getChromecastButton()) {
						domUtils.hide(this._getChromecastButton());
					}
				}
			},

			_sessionUpdateListener: function (session) {
				if (!session) {
					//MessageChannel.publish('/player/chromecast/inactive/' + this.video.playerID);
					this.session = null;
					this._stopSession();
				} else {
					_sendEvent('volumechange');
				}
			},

			_sessionCommandListener: function (namespace, commandStr) {
				if (namespace === NAMESPACE.SEND_COMMAND) {
					let command;
                    let sendSubStatus;
                    let sendAudioStatus;

					try {
						command = JSON.parse(commandStr).command;
					} catch (e) {}

					switch (command) {
						case COMMANDS.SUBS_OFF:
							_sendEvent('captionsvisible', { shouldShow: false });
							sendSubStatus = true;
							break;
						case COMMANDS.SUBS_ON:
							_sendEvent('captionsvisible', { shouldShow: true });
							sendSubStatus = true;
							break;
                        case COMMANDS.AUDIO_DEFAULT:
                        case COMMANDS.AUDIO_SPOKEN:
                            sendAudioStatus = true;
                            break;
						case COMMANDS.WAN_CONNECTION_LOST:
							_sendEvent('error', {error: 'connectionLost'});
							break;
						case COMMANDS.WAN_CONNECTION_RESTORED:
							// restore state
							break;
					}

					if (!this._subAvailableSent && sendSubStatus) {
                        const shouldShow = domUtils.getStoredData(CAPTIONS_STORAGE_KEY) === 'true';

                        if (api.state() && api.state().ready) {
                            api.showCaptions(shouldShow);
                        }

                        _sendEvent('captionsloaded');
                        this._subAvailableSent = true;
					}

					if (!this._audioAvailableSent && sendAudioStatus) {
                        let preferredAudioTrack = domUtils.getStoredData(AUDIO_STORAGE_KEY) || 'sv';
                        api.setAudioTrack(preferredAudioTrack);
						this._audioAvailableSent = true;
					}
				}
			},

			_onInitSuccess: function () {
				chrome.cast.addReceiverActionListener(this._receiverActionListener.bind(this));
			},

			_onInitError: function (err) {
			    // empty
			},

			_onLaunchError: function (err) {
                // empty
			},

			_onMediaDiscovered: function (how) {
				this._initMediaListeners();

				if (how === 'loadMedia') {
					this._isCurrentCastVideo = true;
				}

				var mediaObj = this.getMedia();
				if (mediaObj) {
					if (how === 'activeSession') {
						this.currentTime = mediaObj.currentTime;
					}

					this.duration = mediaObj.media.duration;
				}

				this._loading = false;
				_sendEvent('playing');
			},

			_onLoadMediaError: function (err) {
				if (!(err && err.description === 'LOAD_CANCELLED')) {
					_sendEvent('error', {error: ErrorType.LOAD_ERROR});
				}
			},

			loadAndPlay: function () {
				if (this.session) {
					this._autostart = true;
					this._loadMediaOnChromecast();
				}
			},

			_requestSession: function () {
				chrome.cast.requestSession(this._sessionFoundListener.bind(this), this._onLaunchError.bind(this));
			},

			_loadMediaOnChromecast: function () {
                api.data().allowNoUi = false;
				api.data().isRemote = true;
				_sendEvent('play');
				// Capture any canplay-events, in case we're not loaded
				if (!api.state().loaded) {
					api.on(EVENT_NAMESPACE + '.canplay', function () {
						_sendEvent('buffering');
						api.off(EVENT_NAMESPACE + '.canplay');

						return false;
					});
				}
				var mediaUrl = this._getVideoUrl();
                var data = this._videoData;

				if (!mediaUrl) {
					_sendEvent('error', {'type': 'device'});

					return;
				}
				Debug('loading', mediaUrl);

				var mediaInfo = new chrome.cast.media.MediaInfo(mediaUrl, 'application/vnd.apple.mpegurl');
                var client = statsUtil.getClient();
                var statsProgramTitle = data.mmsStatistics.ns_st_pr || 'unknown-program';
                var statsEpisodeTitle = data.mmsStatistics.ns_st_ep || 'unknown-episode';
                var thumbnailImage = Sizzle('video', api.element())[0].getAttribute('poster') || api.config.defaultThumbnail;
				if (thumbnailImage.indexOf('http') === -1) {
					thumbnailImage = 'http:' + thumbnailImage;
				}

				var statisticsData = {
					client: client,
						mmsClientNr: statsUtil.getMmsClientNr(),
						programId: data.programVersionId,
						statisticsUrl: statsUtil.getComscoreBaseUrl() + client + '.' + statsProgramTitle + '.' + statsEpisodeTitle,
						title: statsEpisodeTitle,
						category: data.mmsStatistics.ns_st_pl,
						folderStructure: statsProgramTitle
				};

				statisticsData.subSite = statisticsData.subSite || '.desktop';

				mediaInfo.customData = {
					videoId: data.programVersionId,
					statisticsData: JSON.stringify(statisticsData),
					showSubtitles: false,
					source: window.location.href
				};
				var metadataObject = new chrome.cast.media.GenericMediaMetadata();
				metadataObject.images = [
					new chrome.cast.Image(thumbnailImage),
					new chrome.cast.Image(thumbnailImage)
				];

				if (data.mmsStatistics.svt_content_type === 'klipp') {
					metadataObject.title = data.episodeTitle;
					metadataObject.subtitle = '';
				} else {
					metadataObject.title = data.programTitle;
					metadataObject.subtitle = data.episodeTitle;
				}

				mediaInfo.metadata = metadataObject;

				mediaInfo.streamType = data.live ? chrome.cast.media.StreamType.LIVE : chrome.cast.media.StreamType.BUFFERED;
				mediaInfo.duration = data.live && !data.dvr ? 0 : api.video().getDuration() || 0;
				mediaInfo.tracks = [];

				var request = new chrome.cast.media.LoadRequest(mediaInfo);
				request.autoplay = true;

				if (!this._startPosition) {
					if (data.live) {
						request.currentTime = data.dvr ? data.liveStartTimeUTC : 0;
					} else {
						request.currentTime = Number(api.video().getAttribute('data-position') || 0);
					}
				} else {
					request.currentTime = this._startPosition;
				}

				this.currentTime = request.currentTime;
				this.duration = mediaInfo.duration;

				this.session.loadMedia(request, this._onMediaDiscovered.bind(this, 'loadMedia'), this._onLoadMediaError.bind(this));
			},

			_initMediaListeners: function () {
				var mediaObject = this.getMedia(),
					_this = this;

				if (!mediaObject) {
					return;
				}

				mediaObject.addUpdateListener(function () {
					var playerState = mediaObject.playerState,
						media = _this.getMedia();

					if (media) {
						_this.duration = media.media.duration;
						_this.currentTime = media.currentTime;
						_this.updateProgress();
					}

					if (!_this._settingVolume) {
						_sendEvent('volumechange');
					}

					if (_this.seeked &&
						(playerState === chrome.cast.media.PlayerState.PLAYING || playerState === chrome.cast.media.PlayerState.PAUSED)) {
						_sendEvent('seeked');
						_this.seeked = false;
					}

					switch (playerState) {
						case chrome.cast.media.PlayerState.PLAYING:
							_sendEvent('playing');
							_this.startProgressTimer();
							_this._loading = false;
							break;
						case chrome.cast.media.PlayerState.BUFFERING:
							_sendEvent('buffering');
							_this.stopProgressTimer();
							break;
						case chrome.cast.media.PlayerState.PAUSED:
							_this.stopProgressTimer();
							_sendEvent('pause');
							break;
						case chrome.cast.media.PlayerState.IDLE:
							// For some reason, idle gets called when switching video -- disable it during load.
							if (!_this._loading) {
								_this.stopProgressTimer();
								_sendEvent('pause');
								_sendEvent('ended');
								break;
							}
					}

				});
			},

			_receiverActionListener: function (receiver, action) {
				if (action === chrome.cast.ReceiverAction.CAST) {
					api.data().allowNoUi = false;
					api.data().isRemote = true;

					if (api.state().ready) {
						api.pause();
						this._startPosition = api.video().getCurrentTime();
						this._autostart = !!this._startPosition;
					} else {
						this._startPosition = 0;
						this._autostart = false;
					}
					this._setChromecastButtonState(STATUS.CONNECTING);
				} else if (action === chrome.cast.ReceiverAction.STOP) {
					this._stopSession();
				}
			},

			_stopSession: function (isDestroy) {
				if (this.hasLocalSession()) {
					this.session = null;
					this._setChromecastButtonState(STATUS.INACTIVE);
                    removeFromSessionStorage(SESSION_KEY);

					if (!isDestroy) {
						this._resetVideo();
					}
				}
			},

			_resetVideo: function () {
				if (this._isCurrentCastVideo) {
					api.data().isRemote = false;
					if (this.currentTime && (this.duration - this.currentTime) > 15) {
						api.seek(this.currentTime);
						api.play(); //TODO figure out the correct state here, should we match the latest state from remote device?
					}
					api.on(EVENT_NAMESPACE + '.playing', function () {
						api.off(EVENT_NAMESPACE + '.playing');
						api.data().allowNoUi = true;
					});
				}
			},

			startProgressTimer: function () {
				var _this = this;

				if (!this.timer) {
					this.timer = setInterval(function () {
						if (!_this.session) {
							return;
						}

						_this.currentTime += 1;
						_this.updateProgress();
					}, 1000);
				}
			},

			stopProgressTimer: function () {
				clearInterval(this.timer);
				this.timer = null;
			},

			updateProgress: function () {
				var media = this.getMedia();

				if (!media) {
					this.stopProgressTimer();

					return;
				}

				_sendEvent('timeupdate', this.currentTime);
			},

			pause: function () {
				var media = this.getMedia();
				if (media) {
					var _this = this;
					media.pause(null, function () {
						_this.stopProgressTimer();
						_sendEvent('pause');
					}, function () {
						_sendEvent('error');
					});
				}
			},

			play: function () {
				var media = this.getMedia();
				if (media) {
					var _this = this;
					media.play(null, function () {
						_sendEvent('playing');
						_this.startProgressTimer();
					}, function () {
						_sendEvent('error');
					});
				} else {
					this.loadAndPlay();
				}
			},

			seek: function (position) {
				var media = this.getMedia();
				var _this = this;

				if (!media) {
					return;
				}

				_sendEvent('seeking');
				this.stopProgressTimer();
				var request = new chrome.cast.media.SeekRequest();
				request.currentTime = position;

				media.seek(request, function () {
					_this.seeked = true;
				}, function (e) {
					Debug.error(e);
					_sendEvent('error');
				});
			},

			setVolume: function (level) {
				if (!this.session) {
					return;
				}

				var _this = this;
				this._settingVolume = true;
				this.session.setReceiverVolumeLevel(level, function () {
					_this._settingVolume = false;
				}, function () {
					_this._settingVolume = false;
				});
			},

			getVolume: function () {
				return this.session && this.session.receiver.volume.level;
			},

			mute: function (shouldMute) {
				if (!this.session) {
					return;
				}

				var _this = this;
				this._settingVolume = true;
				this.session.setReceiverMuted(shouldMute, function () {
					_this._settingVolume = false;
					_sendEvent('volumechange');
				}, function () {
					_this._settingVolume = false;
				});
			},

			isMuted: function () {
				return this.session && this.session.receiver.volume.muted;
			},

			showCaptions: function (shouldShow) {
				var command = shouldShow ? COMMANDS.SUBS_ON : COMMANDS.SUBS_OFF;
				this._sendCommand(command, false, function (e) {
					Debug.error(e);
				});
			},

            setAudioTrack: function (trackId) {
                let command = trackId === AudioTrack.SPOKEN_TEXT ? COMMANDS.AUDIO_SPOKEN : COMMANDS.AUDIO_DEFAULT;
			    this._sendCommand(command, false, (e) => {
			        Debug.error(e);
                });
            },

			getMedia: function () {
				var mediaObject = this.session && this.session.media && this.session.media.length && this.session.media[0].media.customData ? this.session.media[0] : null;
				// The media object is only valid if it belongs to the current video being browsed.

				return mediaObject && this._videoData && mediaObject.media.customData.videoId === this._videoData.programVersionId ? mediaObject : null;
			},

			isActive: function () {
				return this.session !== null;
			},

			hasLocalSession: function () {
				return Boolean(getFromSessionStorage(SESSION_KEY));
			},

			_getVideoUrl: function () {
				if (!this._videoData) {
					return '';
				}

				var videoRefs = this._videoData.videoReferences,
						videoUrl,
						hlsUrl,
						hlsWebVttUrl;
				for (var i = 0; i < videoRefs.length; i++) {
					if (videoRefs[i].format === 'hlswebvtt') {
						hlsWebVttUrl = videoRefs[i].url;
					} else if (videoRefs[i].format === 'hls') {
						hlsUrl = videoRefs[i].url;
					}
				}

				videoUrl = hlsWebVttUrl || hlsUrl;

				if (videoUrl && !videoUrl.match(/svtklipp/)) {
					var newUrlQueryMarker = videoUrl.indexOf('?') > -1 ? '&' : '?';
					videoUrl += newUrlQueryMarker + '__b__=' + START_BITRATE + '&b=0-' + MAX_BITRATE;
				}

				return videoUrl;
			},

			_sendCommand: function (command, successFn, errFn) {
				if (!this.session) {
					if (errFn) {
						errFn('SESSION_ERROR');
					}

					return;
				}

                var success = successFn || function () {
				    // empty
                };
                var cmdJsonString = JSON.stringify({command: command});

				this.session.sendMessage(NAMESPACE.SEND_COMMAND, cmdJsonString, success, errFn);
			},

			_setChromecastButtonIcon: function (iconClass) {
				var _this = this;
				[ICON.CC_CONNECTING_0, ICON.CC_CONNECTING_1, ICON.CC_CONNECTING_2, ICON.CC_OFF, ICON.CC_ON].forEach(function (className) {
					domUtils.removeClass(_this._getChromecastButton(), className);
				});
				domUtils.addClass(this._getChromecastButton(), iconClass);
			},

			_setChromecastButtonState: function (state) {

				clearInterval(this._buttonIconLoadingTimer);
				switch (state) {
					case STATUS.ACTIVE:
						this._setChromecastButtonIcon(ICON.CC_ON);
						break;
					case STATUS.CONNECTING:
						this._setChromecastButtonIcon(ICON.CC_CONNECTING_0);
						this._startLoadingIndicator();
						break;
					default:
						this._setChromecastButtonIcon(ICON.CC_OFF);
				}
			},

			_startLoadingIndicator: function () {
				var counter = 1,
					_this = this;

				this._buttonIconLoadingTimer = setInterval(function () {
					var nextIcon = counter % 4;
					counter++;

					_this._setChromecastButtonIcon(ICON['CC_CONNECTING_' + nextIcon]);
				}, 400);
			}
		};

		if (typeof chrome !== 'undefined') {
			this.chromecastController.loadChromeCast();
			var _this = this;
			api.filters.push({
				load: function () {
					if (_this.chromecastController.isActive()) {
						_this.chromecastController._loading = true;
					}
				},
				play: function () {
					if (_this.chromecastController.isActive()) {
						_this.chromecastController.play();

						return true;
					}
				},
				pause: function () {
					if (_this.chromecastController.isActive()) {
						_this.chromecastController.pause();

						return true;
					}
				},
				seek: function (position) {
					if (_this.chromecastController.isActive()) {
						_this.chromecastController.seek(position);

						return true;
					}
				},
				getDuration: function () {
					if (_this.chromecastController.isActive()) {
						return _this.chromecastController.duration;
					}

					return null;
				},
				getCurrentTime: function () {
					if (_this.chromecastController.isActive()) {
						return _this.chromecastController.currentTime;
					}

					return null;
				},
				getVolume: function () {
					if (_this.chromecastController.isActive()) {
						return _this.chromecastController.getVolume();
					}

					return null;
				},
				isMuted: function () {
					if (_this.chromecastController.isActive()) {
						return _this.chromecastController.isMuted();
					}

					return null;
				},
				mute: function (shouldMute) {
					if (_this.chromecastController.isActive()) {
						_this.chromecastController.mute(shouldMute);

						return true;
					}
				},
				showCaptions: function (shouldShow) {
					if (_this.chromecastController.isActive()) {
						_this.chromecastController.showCaptions(shouldShow);

						return true;
					}
				},
                setAudioTrack: function (trackId) {
                    if (_this.chromecastController.isActive()) {
                        _this.chromecastController.setAudioTrack(trackId);
                    }
                },
				setVolume: function (volume) {
					if (_this.chromecastController.isActive()) {
						_this.chromecastController.setVolume(volume);

						return true;
					}
				}
			});

			api.on(EVENT_NAMESPACE + '.metadata', this.chromecastController.setMetadata.bind(this.chromecastController));
			// This is a workaround for Flash -- hide the button if the flash-player is initialized
			api.on(EVENT_NAMESPACE + '.initialized', function () {
				_this.chromecastController.disallowed = true;
				domUtils.hide(_this.chromecastController._getChromecastButton());
			});
		}
	},
	destroy: function (api) {
		api.off(EVENT_NAMESPACE + '.metadata');
		api.off(EVENT_NAMESPACE + '.error');
	}
};



// WEBPACK FOOTER //
// ./src/js/plugins/chromecast.js